import { nameof } from "../../../../utils/nameof";
import {
  DescribeMissingField,
  entriesMissing,
  financialHoldingsEntriesField,
  itemField,
} from "../../utils/missingFields.utils";
import { AssetsFormValues } from "./AssetsView.types";
import { FINANCIAL_HOLDING_KINDS } from "./AssetsView.utils";

const ANSWERS = nameof<AssetsFormValues>("answers");
const FINANCIAL_HOLDINGS = nameof<AssetsFormValues>("financialHoldings");

export const describeMissingAssetField: DescribeMissingField<AssetsFormValues> = (missing, values, t) => {
  if (missing.itemId !== null) {
    return itemField(FINANCIAL_HOLDINGS, values.financialHoldings, missing);
  }

  const emptyKind = FINANCIAL_HOLDING_KINDS.find(({ kind }) => financialHoldingsEntriesField(kind) === missing.field);
  return emptyKind ? entriesMissing(`${ANSWERS}.${emptyKind.entryField}`, t) : { path: `${ANSWERS}.${missing.field}` };
};
